var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Mixins, Component } from 'vue-property-decorator';
import CanBase from '@/mixins/can/base';
var resource = 'customer';
var CanCustomer = /** @class */ (function (_super) {
    __extends(CanCustomer, _super);
    function CanCustomer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CanCustomer.prototype, "$CustomerPolicy", {
        get: function () {
            return this.$Policies.customers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanCustomer.prototype, "canIndexCustomer", {
        get: function () {
            return this.$CustomerPolicy.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanCustomer.prototype, "canCreateCustomer", {
        get: function () {
            return this.$CustomerPolicy.create;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanCustomer.prototype, "canUpdateCustomer", {
        get: function () {
            return this.$can(resource, 'update');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanCustomer.prototype, "canDeleteCustomer", {
        get: function () {
            return this.$can(resource, 'delete');
        },
        enumerable: false,
        configurable: true
    });
    CanCustomer = __decorate([
        Component
    ], CanCustomer);
    return CanCustomer;
}(Mixins(CanBase)));
export default CanCustomer;
